import { formatNumber } from '@dataplace.ai/functions/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { IEstimates } from '../../organisms/Tiles/Potential/SalesPotential/@types/ISalesPotentialTileData'

const EstimationsWrapper = styled.div(({ theme }) => {
  const {
    typography, palette,
  } = theme
  return css`
    display: flex;
    border-bottom: 1px solid #EDF0F5;
    margin-bottom: 30px;

    > div {
      width: 50%;
      padding: 1rem 0;

      > span {
        display: block;
        font-weight: ${typography.main.pt_15_semibold.fontWeight};
        font-size: ${typography.main.pt_15_semibold.fontSize};
        line-height: ${typography.main.pt_15_semibold.lineHeight};
        color: ${palette.black};
        text-transform: capitalize;
        display: flex;
        align-items: center;
        padding-bottom: 10px;

        .currency {
          text-transform: none;
          margin-left: 5px;
        }

        > strong {
          font-weight: ${typography.big.pt_28_semibold.fontWeight};
          font-size: ${typography.big.pt_28_semibold.fontSize};
          line-height: ${typography.big.pt_28_semibold.lineHeight};
          color: ${palette.black};
          margin-left: 0.5rem;
        }
      }
    }
  `
})

export const Estimations: React.FC<{translation: string, value: IEstimates}> = ({
  translation, value,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <h4>{t(`placeme.sales_potential_tile.estimated_${translation}`)}</h4>
      <span>
        {t('generic.daily')}
        {' '}
        <strong>{formatNumber(value?.daily)}</strong>
        {' '}
        <span className='currency'>zł</span>
      </span>
      <span>
        {t('generic.yearly')}
        {' '}
        <strong>{formatNumber(value?.yearly)}</strong>
        {' '}
        <span className='currency'>zł</span>
      </span>
    </div>
  )
}

export const EstimationsBox: React.FC<{value1: IEstimates, value2: IEstimates}> = ({
  value1, value2,
}) => (
  <EstimationsWrapper>
    <Estimations
      translation='transactions'
      value={value1}
    />
    <Estimations
      translation='income'
      value={value2}
    />
  </EstimationsWrapper>
)
